<ng-container *ngIf="!componentType"> 
    <div class="ipm-beat-{{viewType}}"
    [class.tab-list-view]="isTabView && viewType === 'list'"
    [class.tab-grid-view]="isTabView && viewType === 'grid'"
    [class.tab-grid-object-view]="dataType === 'object' || dataType === 'findData'"
    [class.ipm-sound-kit-grid]="renderType === 'soundKit'" 
    [class.ipm-sound-artist-kit-grid]="renderType === 'artistSoundList' && !isShowFullArtist">
    <ng-container *ngIf="dataType === 'object' || dataType === 'findData'">
        <ng-container
            [ngTemplateOutlet]="gridViewTemplate"
            [ngTemplateOutletContext]="{beat:beatObject}">
        </ng-container>
    </ng-container>
    <ng-container *ngIf="dataType !== 'object' && dataType !== 'findData'">
        <!-- Sound Kits List -->
        <ng-container *ngIf="renderType === 'soundKit'">
            <ng-container *ngIf="soundKitsList.length > 0; else soundKitEmpty">
                <ng-container *ngFor="let soundKit of soundKitsList">
                    <ng-container *ngIf="viewType !== 'list'">
                        <ng-container
                            [ngTemplateOutlet]="soundKitGridTemplate"
                            [ngTemplateOutletContext]="{soundKit:soundKit, isProKit: isProKit}">
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        <!-- Artist Sound Kits List -->
        <ng-container *ngIf="renderType === 'artistSoundList'">
            <ng-container *ngIf="soundKitsList.length > 0; else soundKitEmpty">
                <ng-container *ngFor="let soundKit of soundKitsList">
                    <ng-container *ngIf="viewType !== 'list'">
                        <ng-container
                            [ngTemplateOutlet]="soundArtistKitGridTemplate"
                            [ngTemplateOutletContext]="{soundKit:soundKit, isProKit: isProKit}">
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        
        <!-- Beats List -->
        <ng-container *ngIf="renderType !== 'soundKit' && renderType !== 'artistSoundList'">
            <ng-container *ngIf="beatsList.length > 0; else isDataEmpty;">
                <ng-container *ngFor="let beat of beatsList">
                <div class="ipm-beat-card-list" *ngIf="viewType === 'list'"
                    [ipmAdVisible]="!!beat?.is_ad"
                    (adVisible)="onAdImpression(beat)"
                    (click)="playBeat(beat)">
                    <figure>
                        <div class="ipm-beat-info">
                            <div class="webview-play-icon-section">
                                <div class="ipm-pay-music-beat-section list-view" [class.ipm-beat-playing]="beat?.isBeatPlayed">
                                    <div class="icon-section">
                                        <i class="fa fa-play playIcon ms-1" *ngIf="!beat?.isPlayMusic"></i>
                                        <i class="fas fa-pause" *ngIf="beat?.isPlayMusic"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="ipm-img-wrapper">
                                <img priority priority [src]="beat?.cover_picture" alt="beat-img" class="ipm-img-cover"  width="70" height="70" (error)="commonService.errorHandler($event)">
                                <span class="ipm-disc-badge" *ngIf="commonService.isBeatOnSale(beat)">{{beat?.sale_info?.discount_tier}}%</span>
                                <div class="ipm-overlay-beat-music-section list-view"></div>
                                <div class="ipm-pay-music-beat-section list-view" [class.ipm-beat-playing]="beat?.isBeatPlayed">
                                    <div class="icon-section">
                                        <i class="fa fa-play playIcon ms-1" *ngIf="!beat?.isPlayMusic"></i>
                                        <i class="fas fa-pause" *ngIf="beat?.isPlayMusic"></i>
                                    </div>
                                </div>
                                <div class="ipm-beat-types-tag list-view"
                                    [class.ipm-beat-with-hook]="beat.category === 'beat_with_hook'"
                                    [class.ipm-switch-beat]="beat.category === 'switch_beat'"
                                    *ngIf="beat.category === 'beat_with_hook' || beat.category === 'switch_beat'">
                                <span class="ipm-type-value">{{beat.category | getFilterKeysName : 'beatTypes'}}</span>
                            </div>
                            </div>
                            <figcaption>
                                <div class="ipm-beat-basic">
                                    <span class="ipm-beat-title">
                                        <span class="ipm-text" (click)="$event.stopPropagation();navigateBeatDetails(beat.serial_number, beat)">
                                            {{beat?.title}}
                                        </span>
                                        <span class="ipm-coupon-icon" *ngIf="beat?.available_coupons && beat.available_coupons.length > 0 && !beat?.is_ad">
                                            <img priority src="./assets/imgs/sub-menu/coupon-icon-beat.svg" alt="coupon-icon-beat">
                                        </span>
                                        <!-- <span class="ipm-coupon-icon" *ngIf="(!beat?.available_coupons || (beat.available_coupons && beat.available_coupons.length) === 0) && beat?.allow_negotiations ">
                                            <img priority src="./assets/imgs/filled_negotiation_icon.png" alt="coupon-icon-beat">
                                        </span> -->
                                        <span *ngIf="beat?.is_ad && renderType !== 'artistProfile'"
                                            class="ipm-ad-icon"
                                            (click)="toggleAdPopup($event, beat)">
                                            <img src="assets/imgs/ads-module/ads-icon.png" alt="AD">
                                        </span>
                                    </span>
                                    <span class="ipm-beat-basic-info">
                                        <span class="ipm-artist-details"
                                            (click)="$event.stopPropagation();goToArtistProfile(beat)">
                                            <span class="ipm-store-name">{{beat?.producer?.store?.general?.name}}</span>
                                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg"
                                            alt="verify-icon">
                                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png"
                                            alt="verify-icon">
                                        </span>
                                    </span>
                                    <div class="ipm-tempo-section" *ngIf="!renderType || renderType === 'artistProfile'">
                                        <span><img priority src="./assets/imgs/sub-menu/beat-play.png" alt="beat-play"> {{beat.tempo}} BPM</span>
                                        <span><img priority src="./assets/imgs/sub-menu/audio-icon.png" alt="audio-play"> {{beat.key | getFilterKeysName : 'key'}}</span>
                                    </div>
                                    <div class="ipm-playlist-title" *ngIf="renderType === 'featuredPlaylist'">
                                        <span *ngIf="beat.officialPlaylists !== ''">{{beat.officialPlaylists}}</span>
                                    </div>
                                </div>
                            </figcaption>
                        </div>
                    </figure>
                    <div class="ipm-beat-price-section">
                        <div class="ipm-tags" *ngIf="isPublic">
                            <ul class="ipm-tags-item">
                                <ng-container *ngFor="let tag of beat.tag">
                                    <li *ngIf="tag.trim().length">{{tag}}</li>
                                </ng-container>
                            </ul>
                        </div>
                        <div class="ipm-button-icon">
                            <div class="ipm-price-wrap">
                            <button class="btn" (click)="$event.stopPropagation();priceDialog(beat)" [class.ipm-sale-price-btn]="commonService.isBeatOnSale(beat)"
                                *ngIf="beat.prices && beat.prices.length > 0 && isPublic || (!renderType ||  renderType === 'artistProfile' || renderType === 'featuredPlaylist') " [class.ipm-wav-button]="getUrlName() === 'wav'"
                                [class.ipm-wav-stems-button]="getUrlName() === 'wav_stem'"
                                [class.ipm-exclusive-button]="getUrlName() === 'exclusive'">
                                <i class="pi pi-shopping-cart"></i>
                                <ng-container *ngIf="commonService.isBeatOnSale(beat); else saleNotActive">
                                    <span>{{(beat.prices | getPriceValue : 'single': '':  'sale') | currency:'INR':'symbol':'1.0-0'}}</span>
                                </ng-container>
                                <ng-template #saleNotActive>
                                    <span>{{(beat.prices | getPriceValue : 'single') | currency:'INR' : 'symbol' : '1.0-0'}}</span>
                                </ng-template>
                            </button>
                            <span class="ipm-price-orig" *ngIf="commonService.isBeatOnSale(beat)">{{(beat.prices | getPriceValue : 'single') | currency:'INR':'symbol':'1.0-0'}}</span>
                            </div>
                            <span class="ipm-menu-list" [matMenuTriggerFor]="ipmContent" [matMenuTriggerData]="{menuData : beat}"
                                (click)="$event.stopPropagation()" role="button" tabindex="0" aria-label="Open menu">
                                <i class="pi pi-ellipsis-v menulist"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="viewType !== 'list'">
                    <ng-container *ngIf="renderType === 'soundKit'; else regularGrid">
                        <ng-container
                            [ngTemplateOutlet]="soundKitGridTemplate"
                            [ngTemplateOutletContext]="{beat:beat}">
                        </ng-container>
                    </ng-container>
                    <ng-template #regularGrid>
                        <ng-container
                            [ngTemplateOutlet]="gridViewTemplate"
                            [ngTemplateOutletContext]="{beat:beat}">
                        </ng-container>
                    </ng-template>
                </ng-container>
            </ng-container>
        </ng-container>
        </ng-container>
    </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="componentType">
    <div class="ipm-beat-grid">
        <ng-container *ngFor="let beat of beatsList">
        <ng-container *ngIf="renderType === 'soundKit'; else regularGridComponent">
                <ng-container
                    [ngTemplateOutlet]="soundKitGridTemplate"
                    [ngTemplateOutletContext]="{beat:beat}">
                </ng-container>
            </ng-container>
            <ng-template #regularGridComponent>
                <ng-container
                    [ngTemplateOutlet]="gridViewTemplate"
                    [ngTemplateOutletContext]="{beat:beat}">
                </ng-container>
            </ng-template>
        <!-- <div class="ipm-bpm--arena-beat-card">
            <figure>
                <div class="ipm-beat-info">
                    <div class="ipm-img-wrapper" (click)="playBeat(beat)">
                        <img priority priority [src]="beat?.cover_picture" alt="beat-img" class="ipm-img-cover"  width="70" height="70" (error)="commonService.errorHandler($event)">
                        <div class="ipm-overlay-beat-music-section list-view"></div>
                        <div class="ipm-beat-types-tag list-view"
                            [class.ipm-beat-with-hook]="beat.category === 'beat_with_hook'"
                            [class.ipm-switch-beat]="beat.category === 'switch_beat'"
                            *ngIf="beat.category === 'beat_with_hook' || beat.category === 'switch_beat'">
                        <span class="ipm-type-value">{{beat.category | getFilterKeysName : 'beatTypes'}}</span>
                    </div>
                    </div>
                    <figcaption>
                        <div class="ipm-beat-basic">
                            <span class="ipm-beat-title">
                                <span class="ipm-text" (click)="$event.stopPropagation();navigateBeatDetails(beat.serial_number)">
                                    {{beat?.title}}
                                </span>
                            </span>
                            <span class="ipm-beat-basic-info">
                                <span class="ipm-artist-details"
                                    (click)="$event.stopPropagation();goToArtistProfile(beat.created_by.handle)">
                                    <span class="ipm-store-name">{{beat?.producer?.store?.general?.name}}</span>
                                </span>
                            </span>
                            <div class="ipm-tempo-section">
                                <span><img priority src="./assets/imgs/sub-menu/beat-play.png" alt="beat-play"> {{beat.tempo}} BPM</span>
                            </div>
                        </div>
                    </figcaption>
                    
                </div>
            </figure>
            <div class="ipm-beat-price-section">
                <div class="ipm-button-icon">
                    <div class="webview-play-icon-section">
                        <div class="ipm-pay-music-beat-section list-view" [class.ipm-beat-playing]="beat?.isBeatPlayed"
                            (click)="playBeat(beat)">
                            <div class="icon-section">
                                <i class="fa fa-play playIcon ms-1" *ngIf="!beat?.isPlayMusic"></i>
                                <i class="fas fa-pause" *ngIf="beat?.isPlayMusic"></i>
                            </div>
                        </div>
                    </div>
                    <button class="btn" (click)="$event.stopPropagation();priceDialog(beat)" [class.ipm-sale-price-btn]="commonService.isBeatOnSale(beat)"
                        *ngIf="beat.prices && beat.prices.length > 0 && isPublic" [class.ipm-wav-button]="getUrlName() === 'wav'"
                        [class.ipm-wav-stems-button]="getUrlName() === 'wav_stem'"
                        [class.ipm-exclusive-button]="getUrlName() === 'exclusive'">
                        <i class="pi pi-shopping-cart"></i>
                    </button>
                    <span class="ipm-menu-list" [matMenuTriggerFor]="ipmContent" [matMenuTriggerData]="{menuData : beat}"
                        (click)="$event.stopPropagation()" role="button" tabindex="0" aria-label="Open menu">
                        <i class="pi pi-ellipsis-v menulist"></i>
                    </span>
                </div>
            
            </div>
        </div>    -->
    </ng-container>
    </div>

</ng-container>

<ng-template #gridViewTemplate let-beat="beat">
    <figure class="ipm-beat-grid-card"  [ipmAdVisible]="!!beat?.is_ad"
                    (adVisible)="onAdImpression(beat)">
        <div class="ipm-img-wrapper" (click)="playBeat(beat)">
            <img priority priority [src]="beat?.cover_picture" alt="beat-img" class="ipm-img-cover" priority width="70" height="70" (error)="commonService.errorHandler($event)">
            <span class="ipm-disc-badge" *ngIf="commonService.isBeatOnSale(beat)">{{beat?.sale_info?.discount_tier}}%</span>
            <div class="ipm-overlay-beat-music-section"></div>
            <div class="ipm-pay-music-beat-section grid-view " [class.ipm-beat-playing]="beat?.isBeatPlayed">
                <div class="icon-section">
                    <i class="fa fa-play playIcon" *ngIf="!beat?.isPlayMusic"></i>
                    <i class="fas fa-pause" *ngIf="beat?.isPlayMusic"></i>
                </div>
            </div>
            
            <div class="ipm-beat-types-tag grid-view"
                [class.ipm-beat-with-hook]="beat.category === 'beat_with_hook'"
                [class.ipm-switch-beat]="beat.category === 'switch_beat'"
                *ngIf="beat.category === 'beat_with_hook' || beat.category === 'switch_beat'">
                <span class="ipm-type-value">{{beat.category | getFilterKeysName : 'beatTypes'}}</span>
            </div>
        </div>
        <figcaption class="ipm-beat-other-info-gird">
            <div class="ipm-price-section">
                <div class="ipm-tempo-section">
                    <span><img priority src="./assets/imgs/sub-menu/beat-play.png" alt="beat-play"> <span class="span-text-wrap">{{beat?.tempo}} BPM</span></span>
                </div>
                <div class="ipm-button-icon" *ngIf="beat.prices && beat.prices.length > 0 && isPublic" >
                    <div class="ipm-price-wrap">
                    <button class="btn" (click)="priceDialog(beat)" [class.ipm-sale-price-btn]="commonService.isBeatOnSale(beat)">
                        <i class="pi pi-shopping-cart"></i>
                        <ng-container *ngIf="commonService.isBeatOnSale(beat); else saleNotActive">
                                    <span>{{(beat.prices | getPriceValue : 'single': '':  'sale') | currency:'INR':'symbol':'1.0-0'}}</span>
                        </ng-container>
                        <ng-template #saleNotActive>
                            <span>{{(beat.prices | getPriceValue : 'single') | currency:'INR' : 'symbol' : '1.0-0'}}</span>
                        </ng-template>
                    </button>
                    <span class="ipm-price-orig" *ngIf="commonService.isBeatOnSale(beat)">{{(beat.prices | getPriceValue : 'single') | currency:'INR':'symbol':'1.0-0'}}</span>
                    </div>
                </div>
            </div>
            <div class="ipm-beat-basic-details">
                <div class="ipm-beat-all-details-section">
                    <div class="ipm-beat-basic">
                        <span class="ipm-beat-title">
                            <span class="ipm-text" (click)="navigateBeatDetails(beat.serial_number, beat)">
                                {{beat?.title}}
                            </span>
                            <span class="ipm-coupon-icon" *ngIf="beat?.available_coupons && beat.available_coupons.length > 0 && !beat?.is_ad">
                                <img priority src="./assets/imgs/sub-menu/coupon-icon-beat.svg" alt="coupon-icon-beat">
                            </span>
                            <span *ngIf="beat?.is_ad && renderType !== 'artistProfile'"
                                class="ipm-ad-icon"
                                (click)="toggleAdPopup($event, beat)">
                                <img src="assets/imgs/ads-module/ads-icon.png" alt="AD">
                            </span>
                        </span>
                        <span class="ipm-artist-name" (click)="$event.stopPropagation();goToArtistProfile(beat)">
                            <span class="ipm-store-name"> {{beat?.producer?.store?.general?.name}}</span>
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg"
                            alt="verify-icon">
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png"
                            alt="verify-icon">
                        </span>
                    </div>
                    <div class="ipm-more-button"  [matMenuTriggerFor]="ipmContent" [matMenuTriggerData]="{menuData : beat, itemType: renderType}" role="button" tabindex="0" aria-label="Open menu">
                        <span >
                            <i class="pi pi-ellipsis-v" ></i>
                        </span>
                    </div>
                </div>
            </div>
        </figcaption>
    </figure>
</ng-template>

<ng-template #soundKitGridTemplate let-beat="soundKit" let-proKit="isProKit">
    <figure class="ipm-beat-grid-card ipm-sound-grid-card">
        <div class="inner-border">
        <div class="ipm-img-wrapper" (click)="navigateBeatDetails(beat.serial_number)">
            <img priority [src]="beat?.coverImageUrl" alt="sound-kit-img" class="ipm-img-cover" priority width="70" height="70" (error)="commonService.errorHandler($event)">
        </div>
        <figcaption class="ipm-beat-other-info-gird">
            <div class="ipm-beat-basic-details">
                <div class="ipm-beat-all-details-section">
                    <div class="ipm-beat-basic">
                        <span class="ipm-beat-title">
                            <span class="ipm-text" (click)="navigateBeatDetails(beat.serial_number, beat)">
                                {{beat?.title}}
                            </span>
                            <span class="ipm-coupon-icon" *ngIf="beat?.available_coupons && beat.available_coupons.length > 0 && !beat?.is_ad">
                                <img priority src="./assets/imgs/sub-menu/coupon-icon-beat.svg" alt="coupon-icon-beat">
                            </span>
                            <span *ngIf="beat?.is_ad && renderType !== 'artistProfile'"
                                class="ipm-ad-icon"
                                (click)="toggleAdPopup($event, beat)">
                                <img src="assets/imgs/ads-module/ads-icon.png" alt="AD">
                            </span>
                        </span>
                        <span class="ipm-artist-name">
                            <span class="ipm-store-name"  (click)="$event.stopPropagation();commonService.goToArtistProfile(beat.author.handle)">{{ beat.producer?.name || beat.producer?.store?.general?.name }}</span>
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg" alt="verify-icon">
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png" alt="verify-icon">
                            <span class="ipm-sound-count" *ngIf="beat?.totalFiles">  • {{beat.totalFiles}} sounds</span>
                        </span>
                    </div>
                </div>
                <div class="ipm-price-section">
                    <div *ngIf="beat.price && isPublic">
                        <button class="btn" 
                                [class.ipm-sound-kit-price-btn]="!proKit && !beat?.creditPrice"
                                [class.ipm-pro-kit-price-btn]="proKit || beat.creditPrice > 0"
                                (click)="$event.stopPropagation();priceDialog(beat)">
                            <i class="pi" *ngIf="beat.price.final_price >= 0 && !beat?.creditPrice"
                               [class.pi-shopping-cart]="!proKit && !beat?.creditPrice"
                               [class.pi-crown]="proKit"></i>
                               <ng-container *ngIf="proKit || beat.creditPrice > 0" ><img src="assets/imgs/Lightning.svg" alt="lightning"></ng-container>
                               <ng-container *ngIf="!proKit && !beat?.creditPrice">
                                    <span>{{beat.price.final_price === 0 ? 'Free' : beat.price.final_price | currency:'INR':'symbol':'1.0-0'}} {{proKit ? 'Credits' : '' }}</span>
                               </ng-container>
                               <ng-container *ngIf="proKit || beat.creditPrice > 0">
                                    <span>{{beat.creditPrice === 0 ? 'Free' : beat.creditPrice}} {{'Credits'}}</span>
                               </ng-container>
                           
                        </button>
                    </div>
                    <div class="ipm-more-button ipm-sound-kit-more-button" 
                         [matMenuTriggerFor]="ipmContent" 
                         [matMenuTriggerData]="{menuData : beat, itemType: renderType}" 
                         role="button"
                         tabindex="0" 
                         aria-label="Open menu">
                        <span>
                            <i class="pi pi-ellipsis-v"></i>
                        </span>
                    </div>
                </div>
            </div>
        </figcaption>
        </div>
    </figure>
</ng-template>

<ng-template #soundArtistKitGridTemplate let-beat="soundKit" let-proKit="isProKit">
    <figure class="ipm-beat-grid-card ipm-artist-sound-grid-card ipm-compact-card">
        <div class="inner-border">
        <div class="ipm-img-wrapper" (click)="$event.stopPropagation();navigateBeatDetails(beat.serial_number)">
            <img priority [src]="beat?.coverImageUrl" alt="sound-kit-img" class="ipm-img-cover" priority width="70" height="70" (error)="commonService.errorHandler($event)">
        </div>
        <figcaption class="ipm-beat-other-info-gird">
            <div class="ipm-beat-basic-details">
                <div class="ipm-beat-all-details-section">
                    <div class="ipm-beat-basic">
                        <span class="ipm-beat-title">
                            <span class="ipm-text" (click)="$event.stopPropagation();navigateBeatDetails(beat.serial_number)">
                                {{beat?.title}}
                            </span>
                            <span class="ipm-coupon-icon" *ngIf="beat?.available_coupons && beat.available_coupons.length > 0 && !beat?.is_ad">
                                <img priority src="./assets/imgs/sub-menu/coupon-icon-beat.svg" alt="coupon-icon-beat">
                            </span>
                            <span *ngIf="beat?.is_ad && renderType !== 'artistProfile'"
                                class="ipm-ad-icon"
                                (click)="toggleAdPopup($event, beat)">
                                <img src="assets/imgs/ads-module/ads-icon.png" alt="AD">
                            </span>
                        </span>
                        <span class="ipm-artist-name">
                            <span class="ipm-store-name"  (click)="$event.stopPropagation();commonService.goToArtistProfile(beat.author.handle)">{{ beat.producer?.name || beat.producer?.store?.general?.name }}</span>
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg" alt="verify-icon">
                            <img class="ipm-verify-icon" *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png" alt="verify-icon">
                        </span>
                    </div>
                </div>
                <div class="ipm-price-section">
                    <div *ngIf="beat.price && isPublic">
                        <button class="btn" 
                                [class.ipm-sound-kit-price-btn]="!proKit && !beat?.creditPrice"
                                [class.ipm-pro-kit-price-btn]="proKit || beat.creditPrice > 0"
                                (click)="$event.stopPropagation();priceDialog(beat)">
                            <i class="pi" *ngIf="beat.price.final_price >= 0 && !beat?.creditPrice"
                               [class.pi-shopping-cart]="!proKit && !beat?.creditPrice && beat.price.final_price > 0"
                               [class.pi-crown]="proKit"></i>
                               <ng-container *ngIf="proKit || beat.creditPrice > 0" ><img src="assets/imgs/Lightning.svg" alt="lightning"></ng-container>
                               <ng-container *ngIf="!proKit && !beat?.creditPrice">
                                    <span>{{beat.price.final_price === 0 ? 'Free' : beat.price.final_price | currency:'INR':'symbol':'1.0-0'}} {{proKit ? 'Credits' : '' }}</span>
                               </ng-container>
                               <ng-container *ngIf="proKit || beat.creditPrice > 0">
                                    <span>{{beat.creditPrice === 0 ? 'Free' : beat.creditPrice}} {{'Credits'}}</span>
                               </ng-container>
                           
                        </button>
                    </div>
                    <div class="ipm-more-button ipm-sound-kit-more-button" 
                         *ngIf="!proKit"
                         [matMenuTriggerFor]="ipmContent" 
                         [matMenuTriggerData]="{menuData : beat, itemType: renderType}" 
                         role="button"
                         tabindex="0" 
                         aria-label="Open menu">
                        <span>
                            <i class="pi pi-ellipsis-v"></i>
                        </span>
                    </div>
                </div>
            </div>
        </figcaption>
        </div>
    </figure>
</ng-template>



<ng-template #isDataEmpty>
    <ipm-empty-data-message [emptyMessage]="'No beats found!'"  [isShowButton]="false"></ipm-empty-data-message>
</ng-template>

<ng-template #soundKitEmpty>
    <ipm-empty-data-message [emptyMessage]="'No sound kits found!'"  [isShowButton]="false"></ipm-empty-data-message>
</ng-template>

<mat-menu #ipmContent="matMenu" [class]="'ipm-custom-menu'">
    <ng-template matMenuContent let-menuData="menuData" let-itemType="itemType">
        <button mat-menu-item (click)="shareBeatDialog(menuData.serial_number, (itemType === 'soundKit' || itemType === 'artistSoundList') ? 'soundKit' : 'beat')">
            <span><i class="pi pi-share-alt"></i> Share</span>
        </button>
        <button mat-menu-item (click)="downloadMp3(menuData)" *ngIf="renderType !== 'soundKit' && menuData && !menuData?.disable_mp3_download">
            <span><i class="pi pi-download" ></i> Download</span>
        </button>
        <button mat-menu-item (click)="addORemoveBeatIntoFavList(menuData)">
            <span><i class="pi"
                [class.pi-heart]="!menuData.isFav"
                    [class.pi-heart-fill]="menuData.isFav"
                    [class.pi-heart-fill-color]="menuData.isFav"></i> Favorite</span>
        </button>
        <button mat-menu-item (click)="openLyricsEditor(menuData)"
            *ngIf="itemType !== 'soundKit' && currentUserDetails">
            <span><img src="./assets/imgs/icons/lyrics-pad.svg" alt="lyrics" width="18"
                    height="18" class="ipm-icon-white ipm-menu-icon" /> Lyrics</span>
        </button>
    </ng-template>
</mat-menu>
<ipm-common-beats-dialog (nonLoginAlert)="showLoginAlert($event)" (onTriggerPlayEvent)="playBeat($event)" (onTriggerNegotiation)="startNegotiation($event)" #commonSharedCop></ipm-common-beats-dialog>

<ng-template #loginAlertUserPopup let-data>
	<ipm-non-login-user-popup [type]="data.type" [isMusicPlayer]="false"></ipm-non-login-user-popup>
</ng-template>

<ng-template #appliedCoupon let-data>
    <ipm-coupon-applied-popup
        [couponData]="data.couponData"
        [isShowAppliedButton]="true"
        [isDiwaliSale]="data.isDiwaliSale">
    </ipm-coupon-applied-popup>
</ng-template>

<ng-template #negotiationTemplate let-data>
    <ipm-negotiation-pops [state]="'start'" [currentNegotiation]="data.currentBeat" (backButtonEvent)="onClickBackEventTrigger($event)"></ipm-negotiation-pops>
</ng-template>

<ng-template #fullNameUpdateTemplate let-data>
    <div class="ipm-user-update-section">
        <div class="ipm-user-update-heading">
            <h1>Update Name</h1>
        </div>
        <div class="ipm-user-update-body">
            <form class="custom-form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group custom-form-group">
                            <label for="email" class=" text-white w-100 text-left">Email</label>
                            <input type="text"
                                class="form-control"
                                placeholder="Email Address"
                                name="email"
                                autocomplete="off"
                                [value]="currentUserDetails.email"
                                readonly="true" >
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group custom-form-group">
                            <label for="fullName" class=" text-white w-100 text-left">Full Name </label>
                            <input type="text"
                                class="form-control"
                                placeholder="Full Name"
                                name="fullName"
                                autocomplete="off"
                                [(ngModel)]="fullName"
                                (keypress)="formService.keyPressCharacter($event)"
                                (keyup)="!formService.keyPressCharacter($event) ? formService.setControlValue(fullName) : ''"
                                required>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="ipm-user-update-action">
            <button class="btn ipm-checkout-btn"
                [disabled]="!fullName && fullName.length  === 0"
                (click)="updateFullName(data.currentBeat)">
                Update
            </button>
        </div>
    </div>
</ng-template>

<!-- AD Promoted Beat Popup Template -->
<ng-template #adPopupTemplate>
    <div class="ipm-ad-popup" (click)="$event.stopPropagation()">
        <!-- Header row: badge + close button -->
        <div class="ipm-ad-popup-topbar">
            <div class="ipm-ad-popup-header">
                <div class="ipm-ad-badge-icon">
                    <img src="assets/imgs/ads-module/ads-icon.png" alt="AD" class="ipm-ad-popup-icon">
                </div>
                <div>
                    <span class="ipm-ad-badge-label">BOOSTED BEAT</span>
                    <p class="ipm-ad-popup-subline" *ngIf="currentAdBeat?.ad_note?.trim()" >Why you should buy this beat?</p>
                </div>
            </div>
            <div class="ipm-close-icon" (click)="commonService.closePopUp()">
                <i class="pi pi-times"></i>
            </div>
        </div>

        <!-- With ad_note: "[NAME] SAYS" + subline + avatar + quote -->
        <ng-container *ngIf="currentAdBeat?.ad_note?.trim(); else noAdNote">
            <div class="ipm-ad-popup-headline">
                <span class="ipm-ad-producer-name">{{(currentAdBeat?.producer?.store?.general?.name || 'Producer') | uppercase}}</span>
                <span class="ipm-ad-says-text"> SAYS</span>
            </div>
            <div class="ipm-ad-popup-quote">
                <div class="ipm-ad-producer-avatar">
                    <img
                        [src]="currentAdBeat?.producer?.store?.brand?.picture || 'assets/imgs/default-avatar.png'"
                        alt="producer"
                        (error)="commonService.errorHandler($event)">
                </div>
                <div class="ipm-ad-quote-text">
                    <!-- <span class="ipm-ad-quote-mark">&ldquo;</span> -->
                    <p>"{{currentAdBeat?.ad_note}}"</p>
                </div>
            </div>
        </ng-container>

        <!-- No ad_note fallback -->
        <ng-template #noAdNote>
            <p class="ipm-ad-popup-fallback">This beat is being boosted by the studio to reach more listeners like you.</p>
        </ng-template>

    </div>
</ng-template>
